import React from 'react';
import classNames from 'classnames/bind';
import { TextBase } from '../../TextBase';
import styles from './FieldLabel.css';
var cx = classNames.bind(styles);

// TODO: Иправить на импортированные после внедрения DSGen
var getTextColor = function getTextColor(_ref) {
  var disabled = _ref.disabled,
      invalid = _ref.invalid;

  if (disabled) {
    return 'N100';
  }

  if (invalid) {
    return 'R600';
  }

  return 'N100';
};

export var FieldLabel = function FieldLabel(_ref2) {
  var children = _ref2.children,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? {} : _ref2$classes,
      disabled = _ref2.disabled,
      invalid = _ref2.invalid;
  return /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    size: "l",
    color: getTextColor({
      disabled: disabled,
      invalid: invalid
    }),
    classes: {
      root: cx('root', classes === null || classes === void 0 ? void 0 : classes.root)
    }
  }, children);
};